var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6637 13.9957H1.13332C0.933836 13.9957 0.742518 14.0749 0.601458 14.216C0.460399 14.357 0.381152 14.5483 0.381152 14.7478C0.381152 14.9473 0.460399 15.1386 0.601458 15.2797C0.742518 15.4208 0.933836 15.5 1.13332 15.5H11.6637C11.8632 15.5 12.0545 15.4208 12.1956 15.2797C12.3367 15.1386 12.4159 14.9473 12.4159 14.7478C12.4159 14.5483 12.3367 14.357 12.1956 14.216C12.0545 14.0749 11.8632 13.9957 11.6637 13.9957ZM1.13332 12.4913H1.20102L4.33758 12.2055C4.68117 12.1713 5.00252 12.0199 5.24771 11.7767L12.0173 5.0072C12.28 4.72962 12.422 4.35921 12.4121 3.97712C12.4023 3.59504 12.2413 3.23245 11.9646 2.96881L9.90365 0.907858C9.63467 0.655201 9.2822 0.510229 8.91329 0.500521C8.54438 0.490813 8.18477 0.617046 7.90287 0.855206L1.13332 7.62476C0.890196 7.86994 0.738813 8.19129 0.704586 8.53488L0.381152 11.6714C0.37102 11.7816 0.385315 11.8927 0.423019 11.9967C0.460723 12.1007 0.520907 12.1951 0.599282 12.2732C0.669565 12.3429 0.752918 12.398 0.844561 12.4355C0.936203 12.4729 1.03433 12.4919 1.13332 12.4913ZM8.85813 1.9609L10.9116 4.01433L9.40722 5.48107L7.3914 3.46524L8.85813 1.9609Z",
    fill: "#A9876F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeCompany);
export default __webpack_public_path__ + "static/media/changeCompany.693eed78fa0b312cb4cf12c483833c2a.svg";
export { ForwardRef as ReactComponent };